import React from 'react';

import { LoadingSpinner } from '@/components/ui/loading/spinner';

import { Box } from '../box';

const PageLoading = () => {
  return (
    <Box>
      <LoadingSpinner text="Page data" isVisible />
    </Box>
  );
};

export { PageLoading };
